<script setup lang="ts">
import BaseModal from "~/components/Base/BaseModal.vue";
import QuickViewProductDetails from "~/components/ProductPage/QuickViewProductDetails.vue";

// -----------------------
// props
// -----------------------
defineProps<{
  show: boolean;
  product: Record<string, any> | null;
  restoreMainProductOnClose?: boolean;
}>();

// -----------------------
// emits
// -----------------------
const emit = defineEmits<{
  close: [];
}>();

// -----------------------
// helper functions
// -----------------------
const handleClose = () => {
  emit("close");
};

const handleAddedToCart = () => {
  // Close modal after adding to cart
  emit("close");
};
</script>

<template>
  <BaseModal
    :show="show"
    :width="900"
    :height="600"
    :closeable="true"
    :autoclose="true"
    bgcolor="bg-white"
    @close="handleClose"
  >
    <div v-if="product" class="quick-view-modal">
      <QuickViewProductDetails
        :product="product"
        :restore-main-product-on-close="restoreMainProductOnClose"
        @close="handleClose"
        @added-to-cart="handleAddedToCart"
      />
    </div>
  </BaseModal>
</template>

<style scoped>
.quick-view-modal {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
